<template>
  <div>
    <div class="headimg" :style="{height:imgHeight}">
      <img :src="bannersrc" alt="">
    </div>
    <div class="contain">
      <div class="contain-top">
        <ul>
          <li v-for="(items,index) in liList"
              v-html="items.name"
              @click="handleClick(items.comName,index)"
              :class="{active:index==current}"
          >
          </li>
        </ul>
      </div>
      <div style="overflow: hidden">
        <component :is="comName"></component>
      </div>

    </div>
  </div>

</template>

<script>
import Cishidai from "../components/Cishidai";
import Vir from "../components/Vir";
import Zitai from "../components/Zitai";


export default {
  name:'FuheAi',
  components:{
    Cishidai,
    Vir,
    Zitai
  },
  data() {
    return {
      liList:[
        {name:'虚拟仿真',comName:'Vir'},
        {name:'红亚姿态捕捉识别\n' +
              '            <br>\n' +
              '            和分析管理系统',comName:'Zitai'},
        {name:'裸眼3D',comName: 'Cishidai'}
      ],
      comName:'Zitai',
      windowWidth: window.innerWidth + "px", //实时屏幕宽度
      imgHeight:(window.innerWidth * 0.32) + "px",
      current: 1,
      bannersrc:require("../assets/img/zitai/zitai.png"),
      bannerList:[
        require("../assets/img/zitai/vir.png"),
        require("../assets/img/zitai/zitai.png"),
        require("../assets/img/zitai/3DBanner.png")
      ],
    };
  },
  created() {
  },
  mounted() {
  },
  watch:{

  },
  methods: {
    //点击li
    handleClick(eventName,i) {
      this.comName = eventName
      this.current = i
      this.bannersrc = this.bannerList[i]
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/FuheAi.scss';
</style>

